import { FieldValues, UseFormSetValue } from 'react-hook-form';

export function resetRelatedFieldOnAddressOptionChange(
  fields: string[],
  setValue: UseFormSetValue<FieldValues>,
) {
  fields.forEach((name) => {
    setValue(name, '');
  });
}
